import gql from "graphql-tag";
const resendEmail = gql`
 query resendEmail($resendInput: ResendEmailInput!) {
    resendEmail(resendInput: $resendInput) {
     	success
      mailSent
      notConfirmed
      message
      err
    }
  }
`;

export default resendEmail;